import { render } from "./Receive.vue?vue&type=template&id=3d2c2d4e&scoped=true&ts=true"
import script from "./Receive.vue?vue&type=script&lang=ts"
export * from "./Receive.vue?vue&type=script&lang=ts"

import "./Receive.vue?vue&type=style&index=0&id=3d2c2d4e&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2c2d4e"]])

export default __exports__